<template>
  <footer class="footer">
    <p class="logo">Rizes House</p>
    <p class="address">{{ $t('footer.address') }}</p>
    <div class="info">
      <div class="info__contact">
        <!-- <span class="mdi mdi-phone ico"></span> -->
        <!-- <i class="fas fa-mobile-alt"></i> -->
        <img src="@/assets/icons/ico-mobile.svg" alt="" />
        <p class="tel">6948236910</p>
      </div>
      <div class="info__contact">
        <!-- <span class="mdi mdi-email-outline ico"></span> -->
        <!-- <i class="far fa-envelope"></i> -->
        <img src="@/assets/icons/ico-envelope.svg" alt="" />
        <p>evkamba@gmail.com</p>
      </div>
    </div>
    <div class="social">
      <a
        href="https://www.facebook.com/Rizes-House-242018223052660"
        target="_blank"
      >
        <!-- <i class="fab fa-facebook"></i> -->
        <img src="@/assets/icons/ico-facebook.svg" alt="" />
      </a>
      <a href="https://www.instagram.com/rizeshouse/" target="_blank">
        <!-- <i class="fab fa-instagram"></i> -->
        <img src="@/assets/icons/ico-instagram.svg" alt="" />
      </a>
      <a
        href="https://www.facebook.com/Rizes-House-242018223052660"
        target="_blank"
      >
        <!-- <i class="fab fa-twitter"></i> -->
        <img src="@/assets/icons/ico-twitter.svg" alt="" />
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  data: () => ({
    address: 'Ιατρού Κατσαούνη Σπυρίδων, Άγιος Νικόλαος, 63078, Ελλάδα',
  }),
  methods: {},
  computed: {},
};
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  background-color: hsl(var(--clr-primary-700));
  padding: var(--size-8-6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--size-4-3);
}

.logo {
  font-size: var(--fs-11-10);
}

.address {
  font-family: var(--ff-serif);
  font-size: 20px;
  color: hsl(var(--clr-primary-100));
}

.info {
  display: flex;
  color: hsl(var(--clr-primary-100));
  font-size: var(--fs-4-3);

  &__contact {
    display: flex;
    align-items: center;

    img {
      margin-right: 8px;
    }
  }

  &__contact + &__contact {
    margin-left: 40px;
  }
}

.social {
  a {
    text-decoration: none;
    color: hsl(var(--clr-primary-100));
    font-size: var(--fs-7-5);
  }
  a + a {
    margin-left: 48px;
  }
}
</style>
